import Vue from 'vue'
import App from './App.vue'
import router  from './router';
import Vuelidate from "vuelidate";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios'

Vue.prototype.$http = axios;
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(IconsPlugin);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
